/**
 * 查询组件配置信息
 */

// 查询条件
const equation = [
  { label: '是', value: 'EQ' },
  { label: '为空', value: 'EMPTY' }, // EQ
  { label: '不是', value: 'NE' },
  { label: '非空', value: 'NEMPTY' }, // NE
  { label: '包含', value: 'CP' },
  { label: '不包含', value: 'NP' },
  { label: '开头为', value: 'CP-S' }, // CP
  { label: '结尾为', value: 'CP-E' }, // CP
  { label: '介于', value: 'BT' },
  { label: '大于', value: 'GT' },
  { label: '小于', value: 'LT' },
  { label: '小于等于', value: 'LE' },
  { label: '大于等于', value: 'GE' }
]

export const screenEquation = [
  { label: '单值', value: 'EQ' },
  { label: '小于或等于', value: 'LE' },
  { label: '大于或等于', value: 'GE' },
  { label: '大于', value: 'GT' },
  { label: '小于', value: 'LT' },
  { label: '不等于', value: 'NE' },
  { label: '间隔', value: 'BT' }
]

export const filterOptions = (options = [], type) => {
  return equation.reduce((pre, cur) => {
    if (options.includes(cur.value)) {
      pre.push(cur)
    }
    return pre
  }, [])
}

// 日期选项
export const dopt = filterOptions(['EQ', 'LE', 'GE', 'BT'])

// 下拉框选项
export const sopt = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'BT', 'LE', 'GE'])

// 所有选项
export const aopt = filterOptions(['EQ', 'EMPTY', 'NE', 'NP', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])

// 仅仅只有 是
export const onlyIs = filterOptions(['EQ'])


// WEBPACK FOOTER //
// ./src/utils/query-base.js